// @ts-nocheck
import { digest, slugBuilder } from "./slug-builder";
import { vxiContentInterpreter } from "./vxi-content-interpreter";

export const menuInterpreter = (menuData = [], posts) => {
    const menuSliders = Array.isArray(menuData)
        ? menuData.map((data) => ({
            title: data.attributes.title,
            sliders: data.attributes.sliderList?.map((slide) => ({
                sliderTitle: slide.sliderTitle,
                images: slide.images?.data?.map((img) => img.attributes.url) || [],
            })) || [],
            vxiContent: data.attributes.vxiContent?.data.map((content) => (
                vxiContentInterpreter({
                    ...content.attributes,
                    id: content.id
                })
            )) || null,
            filteredSubMenuLink: data.attributes.filteredSubMenuLink?.map((link) => ({
                filteredLink: link.filteredLink,
                title: link.title
            })) || [],
        }))
        : [];
    // console.log("Menu Sliders:", menuSliders);
    let buildMenu = [];
    // ✅ Step 1: Process `posts` first
    const safePosts = Array.isArray(posts) ? posts : [];
    buildMenu = safePosts.reduce((acc, post) => {
        const { menuTitle, subMenuTitle, title } = post.attributes;

        let menu = acc.find((m) => m.menuTitle === menuTitle || m.menuTitle === title);
        if (!menu) {
            menu = {
                menuTitle: menuTitle ?? title,
                menuTitleURL: null,
                subMenus: [],
                sliders: menuSliders.find(slider => slider.title === menuTitle)?.sliders || [],
                vxiContent: menuSliders.find(slider => slider.title === menuTitle || slider.title === title)?.vxiContent || null
            };
            acc.push(menu);
        }

        // ✅ Ensure subMenu exists
        let subMenu = menu.subMenus.find((s) => s.subMenuTitle === subMenuTitle);
        if (!subMenu) {
            subMenu = { subMenuTitle: subMenuTitle ?? null, titles: [] };
            menu.subMenus.push(subMenu);
        }

        // ✅ Append post titles
        const titleObj = { title, url: slugBuilder(menuTitle, subMenuTitle, title) };
        if (!subMenu.titles.some(t => t.title === title)) {
            subMenu.titles.push(titleObj);
        }
        acc.forEach((a) => {
            if (a.menuTitle === title && !a.menuTitleURL) {
                a.menuTitleURL = slugBuilder(menuTitle, subMenuTitle, title);
            }

            a.subMenus?.forEach((subMenu) => {
                subMenu.titles = subMenu.titles.filter(t => t.title !== a.menuTitle);

                if (subMenu.subMenuTitle === "Industries") {
                    subMenu.titles.sort((a, b) => a.title.localeCompare(b.title));
                }

                if (subMenu.subMenuTitle === "Overview") {
                    const titles = subMenu.titles;

                    const index = titles.findIndex(t => t.title === "Supplier Diversity");

                    if (index !== -1) {
                        const [item] = titles.splice(index, 1); // remove it
                        titles.push(item); // add to end
                    }
                }
            });
        });
        return acc;
    }, []);

    // ✅ Step 2: Ensure all `menuSliders` items exist in `buildMenu`
    menuSliders.forEach((slider) => {
        let menu = buildMenu.find((m) => m.menuTitle === slider.title);
        if (!menu) {
            menu = {
                menuTitle: slider.title,
                menuTitleURL: null,
                subMenus: [],
                sliders: slider.sliders,
                vxiContent: slider.vxiContent
            };
            buildMenu.push(menu);
        }

        // ✅ Ensure filteredSubMenuLink is pushed
        if (slider.filteredSubMenuLink.length > 0) {
            let filteredSubMenu = menu.subMenus.find((s) => s.subMenuTitle === null);
            if (!filteredSubMenu) {
                filteredSubMenu = { subMenuTitle: null, titles: [] };
                menu.subMenus.push(filteredSubMenu);
            }

            slider.filteredSubMenuLink.forEach(link => {
                if (!filteredSubMenu.titles.some(t => t.title === link.title)) {
                    filteredSubMenu.titles.push({
                        title: link.title,
                        url: digest(menu.menuTitle) + "/" + link.filteredLink.split("=")[1].toLowerCase()
                    });
                }
            });
        }
    });

    return buildMenu;
};
